/** Dominio de producción (#43). La dirección vieja de Cloudflare Pages sigue sirviendo la app,
 * pero las funciones del servidor y los enlaces de Auth solo aceptan este dominio, así que quien
 * entra por la vieja se manda aquí con la misma ruta. */
export const DOMINIO = 'https://ops.unipercozumel.com'
const ANTERIORES = ['uniper-ops.pages.dev']

export function destinoCanonico(href: string): string | null {
  const url = new URL(href)
  if (!ANTERIORES.includes(url.hostname)) return null
  return `${DOMINIO}${url.pathname}${url.search}${url.hash}`
}
